import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type QueueDelivery,
  type QueueQuery,
} from "../../../domain/entities/assignment-queue";
import { type RouteAssignmentDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** Asks the backend for the queue narrowed by the day and the search. Returns
 *  null when neither is set, which puts the table back on the full read
 *  instead of spending a request to ask for everything again. */
export const queryQueue = createAsyncThunk<
  QueueDelivery[] | null,
  QueueQuery,
  { dispatch: RouteAssignmentDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.QUERY_QUEUE, async (params, { extra }) => {
  const q = params.q?.trim() ?? "";
  if (!q && !params.dayISO) return null;
  return await extra.routeAssignmentRepo.queryQueue({ q, dayISO: params.dayISO });
});
